import { render, staticRenderFns } from "./ApplicationReview.vue?vue&type=template&id=10fa7cfb"
import script from "./ApplicationReview.vue?vue&type=script&lang=js"
export * from "./ApplicationReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports